import { observable, makeObservable } from 'mobx'

class Validator {

    @observable errors = observable.map({})

    constructor() {
        makeObservable(this)
        console.log('new validator')
        this.validators = new Map()
    }

    clear = () => {
        this.validators.clear()
        this.errors.clear()
    }

    addValidator = (key, validator) => {
        console.log(`addValidator ${key}`)
        if (this.validators.has(key)) {
            return 'invalid'
        }

        this.validators.set(key, validator)
        this.errors.set(key, false)
        console.log(JSON.stringify(this.validators))
    }

    removeValidator = (key) => {
        console.log(`removeValidator ${key}`)
        if (this.validators.has(key)) {
            this.validators.delete(key)
            this.errors.delete(key)
        }
    }

    isValid = () => {
        let valid = true
        console.log(JSON.stringify(this.validators))
        this.validators.forEach((validator, key) => {
            console.log(`validate ${key}`)
            validator()
            valid = valid && !this.errors.get(key)
        })
        return valid
    }
}

export let validator = new Validator()